module.exports = __webpack_public_path__ + "static/image/service/pc/kitchen@3x.jpg?330736d4";